import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Globe,
  FileText
} from "lucide-react";

export default function HomePage() {

  const navigate = useNavigate();

  const pages = [
    {
      title: "Indian Documents",
      subtitle:
        "Invoices, Receipts & Proforma",
      path: "/indian-invoice",
      icon: <FileText size={42} />,
      color: "from-orange-500 to-pink-600",
      bg: "bg-orange-50"
    },
    {
      title: "UK Documents",
      subtitle:
        "Invoices, Receipts & Proforma",
      path: "/uk-invoice",
      icon: <Globe size={42} />,
      color: "from-blue-500 to-cyan-600",
      bg: "bg-blue-50"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-slate-50 to-slate-200 px-4 py-10 sm:px-6 lg:px-10">

      <div className="max-w-6xl mx-auto">

        {/* HEADER */}

        <div className="text-center mb-14">

          <div className="inline-flex items-center gap-3 bg-white border border-slate-200 rounded-full px-5 py-2 shadow-sm mb-5">

            <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />

            <span className="text-sm font-medium text-slate-600">
              SPORTSNTW Document System
            </span>

          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-800 leading-tight">

            Document Dashboard

          </h1>

          <p className="text-slate-500 text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
            Generate professional invoices,
            receipts and Proforma invoices
            for India and UK operations.
          </p>

        </div>

        {/* CARDS */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          {pages.map((page, index) => (

            <button
              key={index}
              onClick={() =>
                navigate(page.path)
              }
              className={`group relative overflow-hidden rounded-[32px] bg-gradient-to-br ${page.color} p-[2px] shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2`}
            >

              {/* INNER */}

              <div
                className={`relative h-full w-full rounded-[30px] ${page.bg} px-8 py-12 sm:px-10 sm:py-14`}
              >

                {/* GLOW */}

                <div
                  className={`absolute top-0 right-0 w-40 h-40 bg-gradient-to-br ${page.color} opacity-10 rounded-full blur-3xl`}
                />

                {/* CONTENT */}

                <div className="relative z-10">

                  {/* ICON */}

                  <div
                    className={`w-20 h-20 rounded-3xl bg-gradient-to-br ${page.color} text-white flex items-center justify-center shadow-lg mb-8 group-hover:scale-110 transition-transform duration-500`}
                  >
                    {page.icon}
                  </div>

                  {/* TITLE */}

                  <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-3 text-left">
                    {page.title}
                  </h2>

                  {/* SUBTITLE */}

                  <p className="text-slate-500 text-base sm:text-lg leading-relaxed text-left">
                    {page.subtitle}
                  </p>

                  {/* BUTTON */}

                  <div className="mt-10 flex items-center justify-between">

                    <div
                      className={`inline-flex items-center gap-2 bg-gradient-to-r ${page.color} text-white px-5 py-3 rounded-2xl font-semibold shadow-md`}
                    >
                      Open Dashboard

                      <span className="text-lg group-hover:translate-x-1 transition-transform duration-300">
                        →
                      </span>
                    </div>

                  </div>

                </div>

              </div>

            </button>

          ))}

        </div>

      </div>

    </div>
  );
}